export default __webpack_public_path__ + "static/gtc-34e0bbca2917b7fc64a29ab399870ced.jpeg";